export const faq = [
  {
    id: "7",
    question: "I have vibe coded an app with AI. Can you help me with deployment?",
    ans: "We can review your implementation and assist you with deploying your AI-powered app to the appropriate stores.",
  },
  {
    id: "1",
    question: "How much does it cost to build an app?",
    ans: "While every app is different, prices usually start at $10k. Try our interactive price calculator to get an estimate.Talk to us about partnerships or monthly payment plan.",
  },
  {
    id: "2",
    question: "Can I provide my own designs?",
    ans: "Sure, we are open to work with any designs you might already have.",
  },
  {
    id: "3",
    question: "Can my app integrate with a 3rd party API?",
    ans: "Sure, in fact all the apps we have built integrate with multiple APIs.",
  },
  {
    id: "4",
    question: "What is the benefit of a cross platform app?",
    ans: "React Native has been a popular and mature cross platform framework. It has the benefit of building once and deploying to both native iOS and Android, saving time and costs.",
  },
  {
    id: "5",
    question: "Will I get to test my app before releasing to the public?",
    ans: "Sure, user acceptance test is a part of our process. You will be able to test the app on your device and provide feedback before we submit it for a public release.",
  },
  {
    id: "6",
    question: "How will you manage the project and status updates?",
    ans: "The project will be divided into smaller tickets using Jira/Trello. You will have constant access to the tickets so yo can see their status. In addition we will send weekly updates.",
  },
];
